// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"ProfileSkeleton_skeleton__5hHZk","avatar":"ProfileSkeleton_avatar__2ohrK","profile":"ProfileSkeleton_profile__3YJ2o"};